import Routing from '../../../vendor/friendsofsymfony/jsrouting-bundle/Resources/public/js/router.min';
import Routes from '../../../public/cdn/bundles/fosjsrouting/routes.json';

Routing.setRoutingData(Routes);

export default {
  install: (Vue) => {
    Vue.config.globalProperties.$path = (key, params = {}) => Routing.generate(key, params);
  },
};
